const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNews(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1__118992",
    cx: 29.9788,
    cy: 36.5,
    r: 32.7038,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFDCB1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1.082549e-7,
    style: {
      stopColor: "#F2E0BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0105,
    style: {
      stopColor: "#F2E0BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3623,
    style: {
      stopColor: "#F9EDD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6986,
    style: {
      stopColor: "#FEF4DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF7E4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1__118992)"
    },
    d: "M58,20h-4.893c-0.996,0-1.92-0.681-2.08-1.664C50.824,17.083,51.785,16,53,16h0.83  c1.624,0,3.081-1.216,3.166-2.839C57.086,11.431,55.71,10,54,10H43h-8h-7v1h-9.852c-1.582,0-3.003,1.162-3.137,2.738  c-0.151,1.779,1.252,3.27,3.002,3.262c0.736-0.003,1.452,0.23,1.987,0.687V21h-7.302c-1.895,0-3.594,1.419-3.693,3.312  c-0.103,1.966,1.42,3.588,3.343,3.672C12.908,29.171,14.101,30,15.5,30h4.411c0.03,0,0.059,0.006,0.089,0.007v4.002  c-0.84,0.057-1.62,0.42-2.176,0.991H11c-1.381,0-2.5,1.119-2.5,2.5c0,1.381,1.119,2.5,2.5,2.5h0.5c1.381,0,2.5,1.119,2.5,2.5  c0,1.381-1.119,2.5-2.5,2.5H5.17c-1.625,0-3.081,1.216-3.166,2.839C1.914,49.569,3.29,51,5,51h4.893c0.996,0,1.92,0.681,2.08,1.664  C12.176,53.917,11.215,55,10,55H9.17c-1.625,0-3.081,1.216-3.166,2.839C5.914,59.569,7.29,61,9,61h35.852  c1.582,0,3.003-1.162,3.137-2.738c0.151-1.779-1.252-3.27-3.002-3.262c-0.883,0.004-1.728-0.34-2.271-1H43v-4h7.302  c1.895,0,3.594-1.419,3.693-3.312C54.101,44.67,52.495,43,50.5,43h-0.208c-0.639-1.125-1.651-2-2.792-2h-4.411  c-0.03,0-0.059-0.006-0.089-0.007v-4.001c0.84-0.057,1.62-0.42,2.176-0.991H52c1.381,0,2.5-1.119,2.5-2.5c0-1.381-1.119-2.5-2.5-2.5  h-0.5c-1.381,0-2.5-1.119-2.5-2.5c0-1.381,1.119-2.5,2.5-2.5h6.33c1.624,0,3.081-1.216,3.166-2.839C61.086,21.431,59.71,20,58,20z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2__118992",
    gradientUnits: "userSpaceOnUse",
    x1: 29.5,
    y1: 57,
    x2: 29.5,
    y2: 9.8119,
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4BCAEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    style: {
      stopColor: "#56CDF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#64D0F3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2__118992)"
    },
    d: "M53,57H16c-5.523,0-10-4.477-10-10V11c0-1.657,1.343-3,3-3h32c1.657,0,3,1.343,3,3v37   C44,52.971,48.029,57,53,57L53,57z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3__118992",
    gradientUnits: "userSpaceOnUse",
    x1: 52.4998,
    y1: 28.3803,
    x2: 52.4998,
    y2: 57.3803,
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#30C3EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1689,
    style: {
      stopColor: "#2BBCE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4065,
    style: {
      stopColor: "#1EAADF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4795,
    style: {
      stopColor: "#19A3DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#18A1DB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3__118992)"
    },
    d: "M52.5,57L52.5,57c-4.694,0-8.5-3.805-8.5-8.5V28h14c1.657,0,3,1.343,3,3v17.5  C61,53.195,57.194,57,52.5,57z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4__118992",
    gradientUnits: "userSpaceOnUse",
    x1: 53.99,
    y1: 29.189,
    x2: 53.99,
    y2: 50.8157,
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#38CAED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6266,
    style: {
      stopColor: "#26B3E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9963,
    style: {
      stopColor: "#1AA3DC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4__118992)"
    },
    d: "M54.973,30.336C54.813,31.319,53.889,32,52.893,32h-1.786c-0.996,0-1.92,0.681-2.08,1.664  C48.824,34.917,49.785,36,51,36h1.5c0.828,0,1.5,0.672,1.5,1.5S53.328,39,52.5,39l-2.877,0c-1.308,0-2.499,0.941-2.63,2.242  C46.844,42.739,48.015,44,49.48,44h6.02c0.828,0,1.5,0.672,1.5,1.5S56.328,47,55.5,47h-1.393c-0.996,0-1.92,0.681-2.08,1.664  C51.824,49.917,52.785,51,54,51h6.625C60.868,50.209,61,49.37,61,48.5V31c0-1.657-1.343-3-3-3h-5  C54.215,28,55.176,29.083,54.973,30.336z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5__118992",
    gradientUnits: "userSpaceOnUse",
    x1: 32.2499,
    y1: 36.9841,
    x2: 32.2499,
    y2: 57.9841,
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.082549e-7,
    style: {
      stopColor: "#40C8EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2DBAE8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5__118992)"
    },
    d: "M12,38.5L12,38.5c0,1.381,1.119,2.5,2.5,2.5H18c1.105,0,2,0.895,2,2v0c0,1.105-0.895,2-2,2h-2  c-1.105,0-2,0.895-2,2v0c0,1.105,0.895,2,2,2h7c1.105,0,2,0.895,2,2v0c0,1.105-0.895,2-2,2h-2c-1.105,0-2,0.895-2,2v0  c0,1.105,0.895,2,2,2h31.5h0c-4.694,0-8.5-3.805-8.5-8.5V36H14.5C13.119,36,12,37.119,12,38.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6__118992",
    gradientUnits: "userSpaceOnUse",
    x1: 15,
    y1: 23,
    x2: 15,
    y2: 8,
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7AD9F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85DBF8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6__118992)"
    },
    d: "M14,19l1.893,0c0.996,0,1.92-0.681,2.08-1.664C18.176,16.083,17.215,15,16,15h-1.5   c-0.828,0-1.5-0.672-1.5-1.5v0c0-0.828,0.672-1.5,1.5-1.5H22c1.215,0,2.176-1.083,1.973-2.336C23.813,8.681,22.889,8,21.893,8L9,8   c-1.657,0-3,1.343-3,3v12l9.893,0c0.996,0,1.92-0.681,2.08-1.664C18.176,20.083,17.215,19,16,19H14L14,19z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7__118992",
    gradientUnits: "userSpaceOnUse",
    x1: 25,
    y1: 33.5417,
    x2: 25,
    y2: 11.9772,
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.018,
    style: {
      stopColor: "#FFF8E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFEF8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_7__118992)"
    },
    d: "M36,27H14c-1.105,0-2-0.895-2-2v-7c0-1.105,0.895-2,2-2h22c1.105,0,2,0.895,2,2v7  C38,26.105,37.105,27,36,27z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M27,36H14c-1.105,0-2-0.895-2-2v0c0-1.105,0.895-2,2-2h13c1.105,0,2,0.895,2,2v0   C29,35.105,28.105,36,27,36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M36,36h-2c-1.105,0-2-0.895-2-2v0c0-1.105,0.895-2,2-2h2c1.105,0,2,0.895,2,2v0   C38,35.105,37.105,36,36,36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M16,50h-2c-1.105,0-2-0.895-2-2v0c0-1.105,0.895-2,2-2h2c1.105,0,2,0.895,2,2v0   C18,49.105,17.105,50,16,50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M36,50H23c-1.105,0-2-0.895-2-2v0c0-1.105,0.895-2,2-2h13c1.105,0,2,0.895,2,2v0   C38,49.105,37.105,50,36,50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M20,43h-6c-1.105,0-2-0.895-2-2v0c0-1.105,0.895-2,2-2h6c1.105,0,2,0.895,2,2v0   C22,42.105,21.105,43,20,43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M36,43h-9c-1.105,0-2-0.895-2-2v0c0-1.105,0.895-2,2-2h9c1.105,0,2,0.895,2,2v0   C38,42.105,37.105,43,36,43z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNews);
export default __webpack_public_path__ + "static/media/ic_news.4cc0bab4048c908e005168291f6c8bbb.svg";
export { ForwardRef as ReactComponent };